import PropTypes from 'prop-types'
import MarketQuartile from './marketQuartile'
import YearlyQuartileScoresReport from './yearlyQuartileScoresReport'

const Market = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  city: PropTypes.string,
  zipcode: PropTypes.string,
  state: PropTypes.string,
  mostRecentFirstQuartile: MarketQuartile,
  mostRecentSecondQuartile: MarketQuartile,
  mostRecentThirdQuartile: MarketQuartile,
  mostRecentFourthQuartile: MarketQuartile,
  quartiles: PropTypes.arrayOf(MarketQuartile),
  yearlyQuartileScoresReports: PropTypes.arrayOf(YearlyQuartileScoresReport)
})

export default Market
